import type {FinishedSaveResponse, Rating} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name RatingDataService
 * @module uc.record
 *
 * @description
 * Service for `Rating` handling
 *
 * @requires service:$http
 */
export default class RatingDataService {
    public static readonly serviceName = 'ratingDataService';
    public static readonly RATING_ROUTE = 'rating';
    public static readonly RECORD_ROUTE = 'records';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getById(recordId: string): Promise<Rating> {
        return this.ajaxService
            .createRequest(`${RatingDataService.RECORD_ROUTE}/${recordId}/${RatingDataService.RATING_ROUTE}`)
            .get();
    }

    public async createRating(recordId: string, value: number): Promise<FinishedSaveResponse<Rating>> {
        return this.ajaxService
            .createRequest(`${RatingDataService.RECORD_ROUTE}/${recordId}/${RatingDataService.RATING_ROUTE}`)
            .post(value.toString());
    }
}